export class Get {
  static readonly type = '[FundingDeskFunnel] Get';
  constructor(public id: number) {}
}

export class GetFundingDeskUsers {
  static readonly type = '[FundingDeskFunnelUsers] Get';
  constructor() {}
}
